module.exports = __webpack_public_path__ + "static/media/radio_newcards.330cb6fc.svg";